import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { nextPage } from 'components/RCPro/helpers/nav'
import Arrow from 'components/assets/icons/Arrow'
import Radio from 'components/common/Radio/Radio'
import Select from 'components/common/Select/Select'
import Input from 'components/common/Input/Input'
import InputError from 'components/common/InputError/InputError'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'
import style from './Insured.module.scss'

const RCProInsured = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const { nextPageTransition } = useOutletContext()
  const { insured, layout } = state.texts
  const other = t('common:other')

  // Initialize form
  const required = t('mainReporting:form.mandatory')
  const {
    register,
    formState: { isValid, errors },
    handleSubmit,
    setValue,
    watch
  } = useForm({
    ...formParams,
    values: {
      insured: state.insured,
      insurer: state.insurer,
      otherInsurer : state.otherInsurer
    },
  })

  insured.insurers = [
    {
      name: 'Hiscox',
      exclusion: true
    },
    { name: 'Axa' },
    { name: 'Allianz' },
    { name: 'Courtier' },
  ]

  const insuredValue = watch('insured')
  useEffect( () => {
    if (insuredValue === insured?.notInsured){
      setValue('insurer', '')
      setValue('otherInsurer', '')
    }
  }, [insuredValue, insured, setValue])

  const onSubmit = handleSubmit(async data => {
    const { exclusion } = insured?.insurers?.find( insurer => insurer.name === data.insurer ) || {}
    if (data.insured === insured?.notInsured){
      data.insurer = ''
    }
    if (exclusion){
      setTimeout( () => {
        navigate('../oups?reason=conflict', { state: { ...state, ...data } })
      }, 250)
    } else {
      nextPage({ pathname, state, navigate, data })
    }
    nextPageTransition()
  })

  return (
    <>
      <h1>{insured?.title} ☂️</h1>
      <p>{insured?.resume}</p>

      <form onSubmit={onSubmit}>
        <Radio
          register={register('insured', { required })}
          className={style.radio}
          checked={watch('insured')}
          values={[
            {
              text: insured?.notInsured,
              value: insured?.notInsured
            },
            {
              text: insured?.alreadyInsured,
              value: insured?.alreadyInsured
            }
          ]}
        />

        {watch("insured") === insured?.alreadyInsured &&
          <Select
            options={[...insured?.insurers, { name: other }].map( insurer => ({
              label: insurer.name,
              value: insurer.name
            }))}
            className={style.insurer}
            onChange={val => {
              setValue('otherInsurer', '')
              setValue('insurer', val.value)
            }}
            value={watch('insurer')}
            label={insured?.insuredLabel}
            placeholder={insured?.insuredPlaceholder}
            styles={{
              control:{
                background: '#FFF'
              }
            }}
          />
        }

        {watch("insurer") === other &&
          <>
            <Input
              error={errors.otherInsurer}
              register={register('otherInsurer', {
                validate: {
                  required: value => {
                    return !value && watch('insurer') === other ? t('mainReporting:form.mandatory') : true
                  },
                }
              })}
              label={insured?.insurerLabel}
              placeholder={insured?.insurerPlaceholder}
            />
            <InputError error={errors.otherInsurer} />
          </>
        }

        <Button
          label={<>{layout?.next} <Arrow /></>}
          onClick={handleSubmit}
          disabled={!isValid || (watch('insured') === insured?.alreadyInsured && !watch('insurer'))}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProInsured